import { create } from 'zustand';

export type CreateKind = 'lead' | 'client' | 'task' | 'employee';

interface CreateState {
  open: CreateKind | null;
  defaults: Record<string, unknown>;
  show: (kind: CreateKind, defaults?: Record<string, unknown>) => void;
  close: () => void;
}

/** Global "quick create" modals, reachable from the top bar and from detail pages. */
export const useCreate = create<CreateState>((set) => ({
  open: null,
  defaults: {},
  show: (open, defaults = {}) => set({ open, defaults }),
  close: () => set({ open: null, defaults: {} }),
}));
